import * as React from 'react';
import {
    unstable_IdlePriority as IdlePriority,
    unstable_runWithPriority as runWithPriority,
} from 'scheduler';

/**
 * Minimum time to wait before considering the browser idle.
 * 2000ms avoid slowing down the initial render.
 */
const MIN_WAIT_TIME = 2000;

/**
 * Hook returning whether the browser is idle (eg. if the React scheduler is free and we have waited enough).
 * @param minWaitTime Minimum time to wait before considering the browser idle.
 */
export function useIsBrowserIdle(): boolean {
    const [isIdle, setIdle] = React.useState(false);

    React.useEffect(() => {
        const timeout = window.setTimeout(
            // Use schedulder to mark as loaded when browser is idle
            () => runWithPriority(IdlePriority, () => setIdle(true)),
            MIN_WAIT_TIME
        );
        return () => {
            clearTimeout(timeout);
        };
    }, []);

    return isIdle;
}
